import React, { Suspense } from 'react';

const ResaleAlertComponent = React.lazy(() => import("../Component/ResaleAlertComponent/ResaleAlertComponent"))

function ResaleAlertPage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <ResaleAlertComponent />
            </Suspense>
        </>
    );
}

export default ResaleAlertPage;